<template>
  <div>
    <vx-card  v-can="'view-supplier-manufacturing-sites'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Supplier Name</label>

          <vs-input type="search"  placeholder="Search.." v-model="filters['company_name']" class="mb-4 md:mb-0 w-full"/>
        </div>
      </div>
      <div class="vx-row mt-5">
        <div class="vx-col w-full ml-auto">
          <vs-button class="float-right mr-4" size="small"
                     color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
        </div>
      </div>
    </vx-card>

    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="SUPPLIER SITES" v-can:any="['view-supplier-manufacturing-sites', 'create-edit-supplier-manufacturing-sites']">
          <template slot="actions">
            <vs-button @click="onCLickCreateManufacturing"  class="mr-4" color="primary" type="filled">Create</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table pagination v-can="'view-supplier-manufacturing-sites'" max-items="10" :data="staff"  @sort="handleSort"   stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th sort-key="name">SITE NAME</vs-th>
                <vs-th sort-key="name">ADDRESS LINE 01</vs-th>
                <vs-th sort-key="name">ADDRESS LINE 02</vs-th>
                <vs-th sort-key="name">PHONE</vs-th>
                <vs-th sort-key="name">EMAIL</vs-th>
                <vs-th sort-key="name">STATUS</vs-th>
                <vs-th v-can="'create-edit-supplier-manufacturing-sites'">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" @click.native="onClickViewManufacturing(data[indextr].id)" :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].site_name">
                    {{ data[indextr].site_name }}
                  </vs-td>
                  <vs-td :data="data[indextr].address_line1">
                    {{ data[indextr].address_line1 }}
                  </vs-td>
                  <vs-td :data="data[indextr].address_line2">
                    {{ data[indextr].address_line2 }}
                  </vs-td>
                  <vs-td :data="data[indextr].site_telephone">
                    {{ data[indextr].site_telephone }}
                  </vs-td>
                  <vs-td :data="data[indextr].site_email">
                    {{ data[indextr].site_email }}
                  </vs-td>
                  <vs-td :data="data[indextr].is_approved">
                    <!--                    {{ data[indextr].is_active }}-->
                    <vs-chip transparent v-if="data[indextr].is_approved === 3 "  color="danger">
                      Not Approved
                    </vs-chip>
                    <vs-chip transparent v-if="data[indextr].is_approved === 2 "  color="primary">
                      approved
                    </vs-chip>
                    <vs-chip transparent v-if="data[indextr].is_approved === 1 "  color="warning">
                      Pending Approval
                    </vs-chip>
                    <vs-chip transparent v-if="data[indextr].is_approved === 0"  color="danger">
                      Pending Submission
                    </vs-chip>
                  </vs-td>

                  <vs-td v-can="'create-edit-supplier-manufacturing-sites'">
                    <div class="vx-row">
                      <vx-tooltip text="View" position="left">
                        <vs-button class="ml-3"
                                   @click="onClickViewManufacturing(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

          </div>
        </vx-card>
      </div>
    </div>
    <create-supplier-pop-up ref="createSupplierPopUp"/>
    <update-supplier-pop-up ref="updateSupplierPopUp"/>
    <view-supplier-pop-up ref="viewSupplierPopUp"/>
    <create-manufacturing-site-pop-up ref="createManufacturingSitePopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const StaffRepository = RepositoryFactory.get('staff')
  const DepartmentsRepository = RepositoryFactory.get('departments')
  const SupplierRepository = RepositoryFactory.get('supplier')
  import CreateSupplierPopUp from '@/components/popups/supplier/CreateSupplierPopUp'
  import UpdateSupplierPopUp from '@/components/popups/supplier/UpdateSupplierPopUp'
  import ViewSupplierPopUp from '@/components/popups/supplier/ViewSupplierPopUp'
  import CreateManufacturingSitePopUp from '@/components/popups/manufacturing-sites/CreateManufacturingSite'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')

  export default {
    name: 'AllUsersList',
    data () {
      return {
        selected: [],
        updateStaffSelected: [],
        options: ['Department 01', 'Department 02', 'Department 03', 'Department 04', 'Department 05', 'Department 06'],
        popupActive: false,
        createUserPopupActive: false,
        popUpTitle: '',
        editActive: false,
        edit: null,
        editProp: {},
        checkBox1: false,
        activeConfirm: false,
        staff: [],
        selectedStaff: {},
        createStaffForm: {},
        departments: [],
        users: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        supplierId: ''
      }
    },
    components: {
      'v-select': vSelect,
      CreateSupplierPopUp,
      UpdateSupplierPopUp,
      ViewSupplierPopUp,
      CreateManufacturingSitePopUp
    },
    mixins : [Filter],
    async mounted () {

      this.$refs.filterCard.isContentCollapsed = true
      this.$refs.filterCard.maxHeight = '1.5rem'

      this.$vs.loading()
      this.loadStaff()
      this.$vs.loading.close()

    },
    methods: {
      async refreshData () {
        this.loadStaff()
      },

      async loadStaff() {
        this.$vs.loading()
        this.supplierId = this.$route.params.id
        const {data} = await SupplierManufactureRepository.getAllManufacturerSites(this.supplierId, this.page, this.filterQuery, 10, this.sort)
        this.staff =  data.data
        this.meta = data.meta
        this.$vs.loading.close()
      },

      openConfirm () {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Remove Confirm',
          text: 'Are you sure you want to permanently remove this organization?',
          accept: this.acceptAlert
        })
      },

      acceptAlert () {
        this.$vs.notify({
          color: 'danger',
          title: 'Deleted Organization',
          position:'top-right',
          text: 'The selected organization was successfully deleted'
        })
      },
      onClickViewManufacturing(id) {
        this.$router.push({path: `/pages/manage-nimble/suppliers/${this.supplierId}/manufacturing/${id}`})
      },
      async onClickCreateSupplier () {
        await this.$refs.createSupplierPopUp.openPopup()
      },
      async onClickSupplierUpdate (id) {
        await this.$refs.updateSupplierPopUp.openPopup(id)
      },
      async onClickSupplierView (id) {
        await this.$refs.viewSupplierPopUp.openPopup(id)
      },
      async onCLickCreateManufacturing() {
        await this.$refs.createManufacturingSitePopUp.openPopup(this.supplierId)
      },
      filterQueryUpdate (){
        this.loadStaff()
      },

      handleChangePage(page) {
        this.page=page;
        this.loadStaff()
      },

      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.loadStaff()
        }

      }

    },
    watch : {
      // page(){
      //   this.loadStaff()
      // }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
